import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2UpdateTableGet, P2UpdateTableService } from '@app/services/p2-update-table.service';

@Component({
    selector: 'tt-p2-update-table-edit',
    templateUrl: './p2-update-table-edit.component.html',
    styleUrls: ['./p2-update-table-edit.component.css'],
    standalone: false,
})
export class P2UpdateTableEditComponent implements OnInit, OnChanges {
    @Input() public p2UpdateTableKeyno?: string;

    @Input() public inline = false;

    @Output() public onSave = new EventEmitter<void>();

    public page?: P2UpdateTableGet;

    public saving = false;

    public readonly tabletSize: MediaQueryList;

    private navigator?: TTViewNavigator;

    constructor(
        private p2UpdateTable: P2UpdateTableService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;

        this.saving = true;

        try {
            await this.p2UpdateTable.saveUpdateTable(this.page);

            if (this.tabletSize.matches && this.inline) {
                this.onSave.emit();
            } else {
                await this.navigator?.back();
            }
        } catch {
            // Leave the editor available for another attempt after a failed save.
        } finally {
            this.saving = false;
        }
    }

    public ngOnInit(): void {
        if (!this.p2UpdateTableKeyno) {
            const routeKeyno = this.navigator?.params['p2_updatetable_keyno'];

            if (routeKeyno !== undefined && routeKeyno !== null) {
                this.p2UpdateTableKeyno = `${routeKeyno}`;
                void this.loadTable(this.p2UpdateTableKeyno);
            }
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        const keyno = changes['p2UpdateTableKeyno']?.currentValue;

        if (keyno !== undefined && keyno !== null) {
            this.p2UpdateTableKeyno = `${keyno}`;
            void this.loadTable(this.p2UpdateTableKeyno);
        }
    }

    private async loadTable(keyno: string): Promise<void> {
        this.page = await this.p2UpdateTable.getUpdateTable({ p2_updatetable_keyno: keyno });
    }
}
